module.exports = __webpack_public_path__ + "assets/img/flag-task-changeTd.22804726.svg";